import { Injectable } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ValidatorsService {

  constructor(
  ) { }

  cardNumber(ctrl: AbstractControl): { cardnum: boolean } {
    if (ctrl.value) {

      let rawCardNumber: string;

      if (ctrl.value.includes('-')) {
        // remove dashes from string, if there is any
        rawCardNumber = ctrl.value.split(' - ').join('');
      } else {
        rawCardNumber = ctrl.value;
      }

      // prefix icc bin number to cardnum
      const cardnum = `141272${rawCardNumber}`;


      // getting user input as string and makes an array of it's digits
      const cardArray = cardnum.split('');

      // temporary variables
      const final = [];
      let sum = 0;

      // main algorithm
      for (let i = 0; i < cardArray.length; ++i) {
        if (i % 2 === 0) {
          const s = (parseInt(cardArray[i], 10) * 2);
          s > 9 ? final[i] = (s - 9) : final[i] = s;
        } else {
          final[i] = (parseInt(cardArray[i], 10) * 1);
        }
      }
      final.forEach(n => {
        sum += n;
      });

      // if INVALID return error map, otherwise null
      return ((sum % 10 === 0) && cardArray.length === 16) ? null : { cardnum: true };
    }
  }

  /**
   * custom max validator
   * it first removes every ',' from the ctrlValue
   * then checks the actual max validation
   * @param value [number]
   */
  max(value: number): ValidatorFn {
    return (ctrl: AbstractControl): { max: boolean } => {
      if (ctrl.value) {
        let ctrlValue = typeof ctrl.value === 'number'
          ? ctrl.value.toString()
          : ctrl.value;

        ctrlValue = parseInt(ctrlValue.replace(/,/g, ''), 10);

        return ctrlValue > value ? { max: true } : null;
      }
    }
  }

  /**
   * custom min validator
   * it first removes every ',' from the ctrlValue
   * then checks the actual min validation
   * @param value [number]
   */
  min(value: number): ValidatorFn {
    return (ctrl: AbstractControl): { min: boolean } => {
      if (ctrl.value) {
        let ctrlValue = typeof ctrl.value === 'number'
          ? ctrl.value.toString()
          : ctrl.value;

        ctrlValue = parseInt(ctrlValue.replace(/,/g, ''), 10);

        return ctrlValue < value ? { min: true } : null;
      }
    }
  }

}
